var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.appClass},[_c(_vm.layout,{tag:"component",attrs:{"component":_vm.layout}},[_c('router-view')],1),_c('CustomToaster')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }